import { ControlType, FormFieldBase } from './form-field-base.model';

export class ChipsSelectFormField extends FormFieldBase<string> {
  controlType: ControlType = 'chips-select';
}
